import ButtonWeb from "./web";
import { ButtonBlockProps } from "./types";

export function ButtonWebEditor(props: ButtonBlockProps) {
  return <ButtonWeb isEditor {...props} />;
}
